// Copyright (c) 2025 Just Feasible Solutions LLC. All rights reserved.
// This file is part of the Just Feasible Solutions application.
// Unauthorized copying, distribution, or modification of this file is prohibited.
// For license information, contact the author.

import React from 'react';

const SecurityPage = () => (
  <div style={{ maxWidth: 900, margin: '0 auto', padding: '2rem' }}>
    <h1>Security</h1>
    <p>
      At Just Feasible Solutions LLC, the security of your data is our top priority. We use a combination of administrative, technical, and physical safeguards to protect your information and ensure the integrity of our services.
    </p>
    <h2>Our Security Practices</h2>
    <ul>
      <li>All data is encrypted in transit using industry-standard TLS (Transport Layer Security).</li>
      <li>Access to your data is restricted to authorized personnel only.</li>
      <li>We regularly update and patch our systems to address security vulnerabilities.</li>
      <li>We use secure authentication and password policies to protect user accounts.</li>
      <li>We monitor our systems for suspicious activity and respond promptly to incidents.</li>
      <li>We never ask for your password or sensitive information via email.</li>
    </ul>
    <h2>Your Responsibilities</h2>
    <ul>
      <li>Use a strong, unique password for your account and do not share it with others.</li>
      <li>Log out of your account when using shared or public devices.</li>
      <li>Be cautious of phishing attempts and suspicious emails.</li>
      <li>Contact us immediately if you suspect unauthorized access to your account.</li>
    </ul>
    <h2>Contact</h2>
    <p>
      If you have any questions or concerns about security, please contact us at <a href="mailto:security@justfeasiblesolutions.com">security@justfeasiblesolutions.com</a>.
    </p>
    <p style={{ marginTop: 32, color: '#888', fontSize: '0.97rem' }}>
      &copy; 2025 Just Feasible Solutions LLC. All rights reserved.
    </p>
  </div>
);

export default SecurityPage;
